import FileSize from "../../../../components/commonComponent/FileSize";
import React, { useState } from "react";
import {
  availableOpportunities,
  careerMarksUpdates,
  careerUpdates,
  internshipSchemeDocument,
} from "../../data/careerDocuments";
import { activeTenders, archiveTenders } from "../../data/tenderDocuments";
import PdfDocumentTable, {
  PdfPreviewModal,
} from "../../../rightToInformation/components/RtiContent/PdfDocumentTable";
import emptyBoxImage from "../../../../assets/images/empty box.png";
import { ArrowLeft } from "lucide-react";

const TENDER_PAGE_SIZE = 10;

const PdfBadge = () => (
  <span className="relative inline-block h-6 w-5 shrink-0 rounded-[3px] bg-[#dfe5ea] shadow-[0_1px_2px_rgba(0,0,0,0.16)]">
    <span className="absolute right-0 top-0 h-0 w-0 border-b-[7px] border-l-[7px] border-b-[#c7d0d8] border-l-transparent" />
    <span className="absolute left-1/2 top-[11px] -translate-x-1/2 whitespace-nowrap rounded-[2px] bg-[#ff5145] px-[3px] py-[1px] text-[7px] font-bold leading-none text-white">
      PDF
    </span>
  </span>
);

const EmptyCareerSection = ({ title }) => (
  <section className="min-w-0 flex-1">
    <h2 className="mb-4 text-[18px] font-bold text-[#16376c]">{title}</h2>
    <div className="rounded-2xl border border-dashed border-[#cad8e6] bg-white px-5 py-8 text-center text-[15px] font-medium text-[#0f5c66] shadow-[0_10px_30px_rgba(0,0,0,0.04)]">
      No documents available.
    </div>
  </section>
);

const ArchiveOpportunities = () => (
  <section className="min-w-0 flex-1">
    <h2 className="mb-4 text-[18px] font-bold text-[#16376c]">
      Archive Opportunities
    </h2>

    <div className="flex min-h-[132px] items-center justify-center rounded-2xl bg-white px-5 py-8 shadow-[0_10px_30px_rgba(0,0,0,0.04)]">
      <div className="flex flex-col items-center gap-3 text-center">
        <img
          src={emptyBoxImage}
          alt=""
          aria-hidden="true"
          className="h-16 w-16 object-contain"
        />
        <p className="m-0 text-[15px] font-medium text-[#16376c]">
          No Archive Opportunities
        </p>
      </div>
    </div>
  </section>
);

const OpportunitiesTable = () => {
  const [selectedOpportunity, setSelectedOpportunity] = useState(null);

  return (
    <>
      <section className="min-w-0 flex-1">
        <h2 className="mb-4 text-[18px] font-bold text-[#16376c]">
          Available Opportunities
        </h2>

        <div className="rounded-2xl bg-white p-4 shadow-[0_10px_30px_rgba(0,0,0,0.04)]">
          <div className="overflow-hidden rounded-xl">
            <div className="overflow-x-auto">
              <table
                className="w-full table-fixed border-collapse text-[14px] text-[#001b33]"
                style={{ minWidth: "1000px" }}
              >
                <colgroup>
                  <col className="w-[72px]" />
                  <col />
                  <col className="w-[155px]" />
                  <col className="w-[190px]" />
                  <col className="w-[260px]" />
                </colgroup>
                <thead>
                  <tr className="bg-[#dce9fb] text-left font-bold text-[#001b33]">
                    <th className="px-4 py-3">S.No.</th>
                    <th className="px-4 py-3">Opportunities</th>
                    <th className="px-4 py-3">Publish Date</th>
                    <th className="px-4 py-3">Last Date</th>
                    <th className="px-4 py-3 text-left">File</th>
                  </tr>
                </thead>
                <tbody>
                  {availableOpportunities.map((opportunity, index) => (
                    <tr
                      key={opportunity.opportunity}
                      className={index % 2 === 0 ? "bg-[#fbfdff]" : "bg-[#f5f9fc]"}
                    >
                      <td className="px-4 py-3 align-middle font-medium">
                        {String(opportunity.serial).padStart(2, "0")}
                      </td>
                      <td className="px-4 py-3 align-middle font-bold text-[#16376c]">
                        <div>{opportunity.opportunity}</div>
                        {opportunity.applicationDocument ? (
                          <a
                            href={opportunity.applicationDocument.href}
                            aria-label={`${opportunity.applicationDocument.title} — ${opportunity.opportunity} (download)`}
                            download={opportunity.applicationDocument.fileName}
                            className="mt-1 inline-block font-medium text-[#004bb8] underline underline-offset-2 transition-colors hover:text-[#0f8a7e]"
                          >
                            {opportunity.applicationDocument.title}<FileSize href={opportunity.applicationDocument.href} fileName={opportunity.applicationDocument.fileName} />


                          </a>
                        ) : opportunity.applyUrl ? (
                          <a
                            href={opportunity.applyUrl}
                            target="_blank"
                            rel="noreferrer"
                            className="mt-1 inline-block font-medium text-[#004bb8] underline underline-offset-2 transition-colors hover:text-[#0f8a7e]"
                          >
                            Apply for {opportunity.opportunity}
                            <span className="sr-only"> (opens in a new tab)</span>
                          </a>
                        ) : null}
                      </td>
                      <td className="px-4 py-3 align-middle">
                        {opportunity.publishDate}
                      </td>
                      <td className="px-4 py-3 align-middle">
                        {opportunity.lastDate}
                      </td>
                      <td className="px-4 py-3 text-left align-middle">
                        <button
                          type="button"
                          onClick={() => setSelectedOpportunity(opportunity)}
                          disabled={!opportunity.href}
                          title={opportunity.fileName || opportunity.opportunity}
                          aria-label={`Open ${opportunity.opportunity}`}
                          className="grid w-full grid-cols-[40px_20px_minmax(0,1fr)] items-center gap-2 whitespace-nowrap rounded-[3px] text-left text-[#16376c] transition-colors hover:text-[#0f8a7e] disabled:cursor-not-allowed disabled:opacity-60"
                        >
                          <span className="text-[13px] font-medium underline underline-offset-2">
                            Open
                          </span>
                          <PdfBadge /><FileSize href={opportunity.href} fileName={opportunity.fileName} />


                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {selectedOpportunity && (
        <PdfPreviewModal
          pdfDocument={selectedOpportunity}
          onClose={() => setSelectedOpportunity(null)}
        />
      )}
    </>
  );
};

const UpdateLink = ({ document, onOpen }) => (
  <button
    type="button"
    onClick={() => onOpen(document)}
    disabled={!document.href}
    title={document.fileName || document.title}
    className="inline text-left text-[15px] font-medium leading-6 text-[#004bb8] underline underline-offset-2 transition-colors hover:text-[#0f8a7e] disabled:cursor-not-allowed disabled:opacity-70"
  >
    {document.title}
    {document.href && (
      <span className="ml-1 inline-flex translate-y-[5px]">
        <PdfBadge /><FileSize href={document.href} fileName={document.fileName} />
      </span>
    )}


  </button>
);

const CareerUpdates = () => {
  const [selectedUpdate, setSelectedUpdate] = useState(null);

  return (
    <>
      <section className="min-w-0 flex-1">
        <h2 className="mb-4 text-[18px] font-bold text-[#16376c]">Updates</h2>

        <div className="rounded-2xl bg-white px-5 py-4 shadow-[0_10px_30px_rgba(0,0,0,0.04)] md:px-7">
          <ul className="m-0 list-disc space-y-2 pl-5 text-[#004bb8]">
            {careerUpdates.map((document) => (
              <li key={document.title} className="pl-1">
                <UpdateLink document={document} onOpen={setSelectedUpdate} />
              </li>
            ))}
          </ul>

          <p className="mb-3 mt-4 text-[15px] font-medium leading-6 text-[#001b33]">
            The marks of candidates appeared for the written test held on
            28/09/2025 and candidates appeared for interview for the post of
            Assistant Manager in various discipline and their final result (
            written + interview) as under:
          </p>

          <ul className="m-0 list-disc space-y-1.5 pl-5 text-[#004bb8]">
            {careerMarksUpdates.map((document) => (
              <li key={document.title} className="pl-1">
                <UpdateLink document={document} onOpen={setSelectedUpdate} />
              </li>
            ))}
          </ul>
        </div>
      </section>

      {selectedUpdate && (
        <PdfPreviewModal
          pdfDocument={selectedUpdate}
          onClose={() => setSelectedUpdate(null)}
        />
      )}
    </>
  );
};

const InternshipScheme = () => {
  const [selectedDocument, setSelectedDocument] = useState(null);

  return (
    <>
      <section className="min-w-0 flex-1">
        <h2 className="mb-4 text-[18px] font-bold text-[#16376c]">
          Internship Scheme
        </h2>

        <div className="rounded-2xl bg-white p-4 shadow-[0_10px_30px_rgba(0,0,0,0.04)]">
          <div className="overflow-hidden rounded-lg">
            <table
              className="w-full table-fixed border-collapse text-[14px] text-[#001b33]"
              style={{ minWidth: "520px" }}
            >
              <colgroup>
                <col />
                <col className="w-[260px]" />
              </colgroup>
              <thead>
                <tr className="bg-[#dce9fb] text-left font-bold text-[#001b33]">
                  <th className="px-5 py-3">Title</th>
                  <th className="px-5 py-3 text-left">File</th>
                </tr>
              </thead>
              <tbody>
                <tr className="bg-white">
                  <td className="px-5 py-3 align-middle font-medium">
                    {internshipSchemeDocument.title}
                  </td>
                  <td className="px-5 py-3 text-left align-middle">
                    <button
                      type="button"
                      onClick={() => setSelectedDocument(internshipSchemeDocument)}
                      disabled={!internshipSchemeDocument.href}
                      title={
                        internshipSchemeDocument.fileName ||
                        internshipSchemeDocument.title
                      }
                      aria-label={`Open ${internshipSchemeDocument.title}`}
                      className="grid w-full grid-cols-[40px_20px_minmax(0,1fr)] items-center gap-2 whitespace-nowrap rounded-[3px] text-left text-[#16376c] transition-colors hover:text-[#0f8a7e] disabled:cursor-not-allowed disabled:opacity-60"
                    >
                      <span className="text-[13px] font-medium underline underline-offset-2">
                        Open
                      </span>
                      <PdfBadge /><FileSize href={internshipSchemeDocument.href} fileName={internshipSchemeDocument.fileName} />


                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {selectedDocument && (
        <PdfPreviewModal
          pdfDocument={selectedDocument}
          onClose={() => setSelectedDocument(null)}
        />
      )}
    </>
  );
};

const ActiveTenders = () => {
  const [selectedTender, setSelectedTender] = useState(null);

  return (
    <>
  <section className="min-w-0 flex-1">
    <h2 className="mb-4 text-[18px] font-bold text-[#16376c]">
      Active Tenders
    </h2>

    {activeTenders.length > 0 ? (
      <div className="rounded-2xl bg-white px-5 py-6 shadow-[0_10px_30px_rgba(0,0,0,0.04)]">
        <div className="overflow-x-auto rounded-lg">
          <table className="w-full min-w-[600px] border-collapse text-left text-[14px] text-[#001b33]">
            <thead>
              <tr className="bg-[#dce9fb] font-bold">
                <th scope="col" className="w-[72px] px-4 py-3">S.No.</th>
                <th scope="col" className="px-4 py-3">Title</th>
                <th scope="col" className="w-[220px] px-4 py-3">File</th>
              </tr>
            </thead>
            <tbody>
              {activeTenders.map((tender) => (
                <tr key={tender.fileName} className="border-b border-[#d9e4ef] bg-[#fbfdff] last:border-b-0">
                  <td className="px-4 py-3 align-middle">{String(tender.serial).padStart(2, "0")}</td>
                  <td className="px-4 py-3 align-middle font-medium">{tender.title}</td>
                  <td className="px-4 py-3 align-middle">
                    <div className="flex flex-wrap items-center gap-3">
                      <button
                        type="button"
                        onClick={() => setSelectedTender(tender)}
                        disabled={!tender.href}
                        className="flex items-center gap-2 font-medium text-[#004bb8] underline underline-offset-2 disabled:cursor-not-allowed disabled:opacity-60"
                        aria-label={`Open ${tender.title}`}
                      >
                        Open <PdfBadge /><FileSize href={tender.href} fileName={tender.fileName} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    ) : (
    <div className="flex min-h-[132px] items-center justify-center rounded-2xl bg-white px-5 py-8 shadow-[0_10px_30px_rgba(0,0,0,0.04)]">
      <div className="flex flex-col items-center gap-3 text-center">
        <img
          src={emptyBoxImage}
          alt=""
          aria-hidden="true"
          className="h-16 w-16 object-contain"
        />
        <p className="m-0 text-[15px] font-medium text-[#16376c]">
          No Active Tenders
        </p>
      </div>
    </div>
    )}
  </section>
      {selectedTender && (
        <PdfPreviewModal
          pdfDocument={selectedTender}
          onClose={() => setSelectedTender(null)}
        />
      )}
    </>
  );
};

const TenderTitleButton = ({ tender, onOpen, onOpenDetails }) => (
  <div className="space-y-1">
    {tender.href ? (
      <button
        type="button"
        onClick={() => onOpen(tender)}
        title={tender.fileName || tender.title}
        className="inline text-left text-[15px] font-medium leading-6 text-[#004bb8] underline underline-offset-2 transition-colors hover:text-[#0f8a7e]"
      >
        {tender.title}<FileSize href={tender.href} fileName={tender.fileName} />


      </button>
    ) : tender.detailDocuments?.length > 0 ? (
      <button
        type="button"
        onClick={() => onOpenDetails(tender)}
        title={`Open ${tender.title}`}
        className="inline text-left text-[15px] font-medium leading-6 text-[#004bb8] underline underline-offset-2 transition-colors hover:text-[#0f8a7e]"
      >
        {tender.title}
      </button>
    ) : (
      <span className="block text-[15px] font-medium leading-6 text-[#001b33]">
        {tender.title}
      </span>
    )}

    {tender.links?.length > 0 && (
      <div className="flex flex-wrap gap-x-3 gap-y-1">
        {tender.links.map((link) => (
          <button
            key={link}
            type="button"
            onClick={() => onOpen(tender)}
            disabled={!tender.href}
            className="text-[15px] font-medium leading-5 text-[#004bb8] underline underline-offset-2 transition-colors hover:text-[#0f8a7e] disabled:cursor-not-allowed disabled:opacity-70"
          >
            {link}<FileSize href={tender.href} fileName={tender.fileName} />


          </button>
        ))}
      </div>
    )}
  </div>
);

const TenderFileButton = ({ tender, onOpen, onOpenDetails }) => (
  tender.fileIcon === "link" ? (
    tender.detailDocuments?.length > 0 ? (
      <button
        type="button"
        onClick={() => onOpenDetails(tender)}
        title={`Open ${tender.title}`}
        aria-label={`Open ${tender.title}`}
        className="text-[13px] font-medium text-[#004bb8] underline underline-offset-2 transition-colors hover:text-[#0f8a7e] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0f8a7e] focus-visible:ring-offset-2"
      >
        Click here
      </button>
    ) : (
      <span aria-hidden="true" />
    )
  ) : (
    <button
      type="button"
      onClick={() => onOpen(tender)}
      disabled={!tender.href}
      title={tender.fileName || tender.title}
      aria-label={`Open ${tender.title}`}
      className="grid w-full grid-cols-[40px_20px_minmax(0,1fr)] items-center gap-2 whitespace-nowrap rounded-[3px] text-left text-[#16376c] transition-colors hover:text-[#0f8a7e] disabled:cursor-not-allowed disabled:opacity-60"
    >
      <span className="text-[13px] font-medium underline underline-offset-2">
        Open
      </span>
      <PdfBadge /><FileSize href={tender.href} fileName={tender.fileName} />


    </button>
  )
);

const ArchiveTenderDocuments = ({ tender, onBack }) => (
  <section className="min-w-0 flex-1 space-y-4">
    <div className="flex items-start gap-3">
      <h2 className="m-0 min-w-0 flex-1 text-[18px] font-bold text-[#16376c]">
        Archive Tenders
      </h2>
      <button
        type="button"
        onClick={onBack}
        className="ml-auto inline-flex shrink-0 items-center gap-2 rounded-[6px] border border-[#0f8a7e] bg-white px-3 py-2 text-[13px] font-bold text-[#0f5c66] transition-colors hover:bg-[#eef8f6] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0f8a7e] focus-visible:ring-offset-2"
      >
        <ArrowLeft size={17} strokeWidth={2.2} />
        Back
      </button>
    </div>

    <PdfDocumentTable
      documents={tender.detailDocuments}
      minWidth="720px"
    />
  </section>
);

const ArchiveTenderTable = () => {
  const [selectedTender, setSelectedTender] = useState(null);
  const [selectedTenderDocuments, setSelectedTenderDocuments] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.max(
    1,
    Math.ceil(archiveTenders.length / TENDER_PAGE_SIZE),
  );
  const startIndex = (currentPage - 1) * TENDER_PAGE_SIZE;
  const visibleTenders = archiveTenders.slice(
    startIndex,
    startIndex + TENDER_PAGE_SIZE,
  );
  const firstVisible = archiveTenders.length === 0 ? 0 : startIndex + 1;
  const lastVisible = Math.min(
    startIndex + visibleTenders.length,
    archiveTenders.length,
  );

  const handlePageChange = (page) => {
    setCurrentPage(Math.min(Math.max(page, 1), totalPages));
  };

  if (selectedTenderDocuments) {
    return (
      <ArchiveTenderDocuments
        tender={selectedTenderDocuments}
        onBack={() => setSelectedTenderDocuments(null)}
      />
    );
  }

  return (
    <>
      <section className="min-w-0 flex-1">
        <h2 className="mb-4 text-[18px] font-bold text-[#16376c]">
          Archive Tenders
        </h2>

        <div className="rounded-2xl bg-white p-4 shadow-[0_10px_30px_rgba(0,0,0,0.04)]">
          <div className="overflow-hidden rounded-lg">
            <div className="overflow-x-auto">
              <table
                className="w-full table-fixed border-collapse text-[14px] text-[#001b33]"
                style={{ minWidth: "900px" }}
              >
                <colgroup>
                  <col className="w-[72px]" />
                  <col />
                  <col className="w-[190px]" />
                  <col className="w-[190px]" />
                  <col className="w-[260px]" />
                </colgroup>
                <thead>
                  <tr className="bg-[#dce9fb] text-left font-bold text-[#001b33]">
                    <th className="px-4 py-3">S.No.</th>
                    <th className="px-4 py-3">Archive</th>
                    <th className="px-4 py-3">Publish Date</th>
                    <th className="px-4 py-3">Last Date</th>
                    <th className="px-4 py-3 text-left">File</th>
                  </tr>
                </thead>
                <tbody>
                  {visibleTenders.map((tender, index) => (
                    <tr
                      key={`${tender.serial}-${tender.fileName}`}
                      className={`border-b border-[#d9e4ef] last:border-b-0 ${
                        index % 2 === 0 ? "bg-[#fbfdff]" : "bg-[#f5f9fc]"
                      }`}
                    >
                      <td className="px-4 py-3 align-middle font-medium">
                        {String(tender.serial).padStart(2, "0")}
                      </td>
                      <td className="px-4 py-3 align-middle">
                        <TenderTitleButton
                          tender={tender}
                          onOpen={setSelectedTender}
                          onOpenDetails={setSelectedTenderDocuments}
                        />
                      </td>
                      <td className="px-4 py-3 align-middle">
                        {tender.publishDate}
                      </td>
                      <td className="px-4 py-3 align-middle">
                        {tender.lastDate}
                      </td>
                      <td className="px-4 py-3 text-left align-middle">
                        <TenderFileButton
                          tender={tender}
                          onOpen={setSelectedTender}
                          onOpenDetails={setSelectedTenderDocuments}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {totalPages > 1 && (
            <div className="mt-4 flex flex-wrap items-center justify-end gap-3 rounded-lg bg-[#f5f5f5] px-4 py-3 text-[13px] text-[#6f7682]">
              <button
                type="button"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                aria-label="Previous tender page"
                className="flex h-8 w-8 items-center justify-center rounded-full text-[#0f5c66] transition-colors hover:bg-white disabled:cursor-not-allowed disabled:opacity-40"
              >
                &lsaquo;
              </button>

              {Array.from({ length: totalPages }, (_, index) => index + 1).map(
                (page) => (
                  <button
                    key={page}
                    type="button"
                    onClick={() => handlePageChange(page)}
                    aria-current={currentPage === page ? "page" : undefined}
                    className={`flex h-8 min-w-[2rem] items-center justify-center rounded-[8px] border px-2 transition-colors ${
                      currentPage === page
                        ? "border-[#0f8a7e] bg-white text-[#0f5c66]"
                        : "border-transparent text-[#6f7682] hover:bg-white"
                    }`}
                  >
                    {page}
                  </button>
                ),
              )}

              <button
                type="button"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                aria-label="Next tender page"
                className="flex h-8 w-8 items-center justify-center rounded-full text-[#0f5c66] transition-colors hover:bg-white disabled:cursor-not-allowed disabled:opacity-40"
              >
                &rsaquo;
              </button>

              <span>
                Showing {firstVisible} to {lastVisible} of{" "}
                {archiveTenders.length} entries
              </span>
            </div>
          )}
        </div>
      </section>

      {selectedTender && (
        <PdfPreviewModal
          pdfDocument={selectedTender}
          onClose={() => setSelectedTender(null)}
        />
      )}
    </>
  );
};

const CareerContent = ({ activeSection, currentSection }) => {
  if (activeSection === "available-opportunities") {
    return <OpportunitiesTable />;
  }

  if (activeSection === "updates") {
    return <CareerUpdates />;
  }

  if (activeSection === "archive-opportunities") {
    return <ArchiveOpportunities />;
  }

  if (activeSection === "nmdfc-internship-scheme") {
    return <InternshipScheme />;
  }

  if (activeSection === "active-tenders") {
    return <ActiveTenders />;
  }

  if (activeSection === "archive-tenders") {
    return <ArchiveTenderTable />;
  }

  return <EmptyCareerSection title={currentSection.label} />;
};

export default CareerContent;
